import React from "react";
import "./WhyMula.css";
import image from "../../../assets/Group 48096931.png";
import arrow from "../../../assets/Monochrome.png";

const WhyMula = () => {
  return (
    <div className="whymula__section">
      <div className="whymula__section__image">
        <img src={image} alt="" />
      </div>
      <div className="whymula__section__text">
        <h3>Why MULA TOKEN</h3>
        <h2>Mula Token Powers the Mula wallet.</h2>
        <p>
          With the beauty and transparency of smart-contracts MULA Token powers
          the MULA FINANCE Ecosystem to facilitate supper fast, secure and
          extremely low-cost cross-border transactions.
        </p>
        <button className="token__section__second__button">
          <div className="token__section__second__button__image">
            <img src={arrow} alt="" />
          </div>
          DOWNLOAD WALLET
        </button>
      </div>
    </div>
  );
};

export default WhyMula;
